import { EnvelopeIcon } from "@heroicons/react/24/outline";
import Layout from "@/components/Layout";

export default function Contact() {
  return (
    <Layout title="Contact">
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">Contact</h1>
        <p className="text-gray-500">Email us if you have a question, feedback, or an issue.</p>
      </div>

      <section className="card max-w-2xl">
        <div className="card-body">
          <a href="mailto:support@scoutux.io" className="btn btn-primary w-fit">
            <EnvelopeIcon className="h-5 w-5" aria-hidden="true" />
            support@scoutux.io
          </a>
          <p className="mt-4 text-sm text-gray-500">We typically respond within 24 hours during business days.</p>
        </div>
      </section>
    </Layout>
  );
}
